import React from 'react'
import '../../styles/MarketPCUI.css'
const MarketPCUI = () => {
  return (
	<div id="market_pc">
	<svg class="usama-akram-kP6knT7tjn4-unspla_">
		<linearGradient id="usama-akram-kP6knT7tjn4-unspla_" spreadMethod="pad" x1="0.5" x2="0.5" y1="0" y2="1">
			<stop offset="0" stop-color="#defe8f" stop-opacity="1"></stop>
			<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
		</linearGradient>
		<rect id="usama-akram-kP6knT7tjn4-unspla_" rx="15" ry="15" x="0" y="0" width="1137" height="285">
		</rect>
	</svg>
	<svg class="usama-akram-kP6knT7tjn4-unspla_ba">
		<rect id="usama-akram-kP6knT7tjn4-unspla_ba" rx="15" ry="15" x="0" y="0" width="1137" height="133">
		</rect>
	</svg>
	<svg class="Rectangle_2">
		<rect id="Rectangle_2" rx="15" ry="15" x="0" y="0" width="1137" height="117">
		</rect>
	</svg>
	<div id="Group_6">
		<div id="Electronics">
			<span>Electronics</span>
		</div>
		<img id="electronics" src="./Market/electronics.png" srcset="./Market/electronics.png 1x" />
			
	</div>
	<div id="Group_5">
		<div id="Grocery">
			<span>Grocery</span>
		</div>
		<img id="shopping-bag" src="./Market/shopping-bag.png" srcset="./Market/shopping-bag.png 1x" />
			
	</div>
	<div id="Group_4">
		<div id="Home">
			<span>Home</span>
		</div>
		<img id="furniture" src="./Market/furniture.png" srcset="./Market/furniture.png 1x"/>
			
	</div>
	<div id="Group_3">
		<div id="Toys">
			<span>Toys</span>
		</div>
		<img id="blocks" src="./Market/blocks.png" srcset="./Market/blocks.png 1x" />
			
	</div>
	<div id="Group_2">
		<div id="Mobile">
			<span>Mobile</span>
		</div>
		<img id="smartphone" src="./Market/smartphone.png" srcset="./Market/smartphone.png 1x" />
			
	</div>
	<div id="Group_1">
		<div id="Top_Offers">
			<span>Top Offers</span>
		</div>
		<img id="shopping-basket" src="./Market/shopping-basket.png" srcset="./Market/shopping-basket.png 1x" />
			
	</div>
	<div id="Group_122">
		<img id="n_2188678_4907157" src="./Market/n_2188678_4907157.png" srcset="./Market/n_2188678_4907157.png 1x" />
			
		<div id="Limited_Offer">
			<span>Limited Offer</span>
		</div>
		<img id="c-d-x-PDX_a_82obo-unsplash" src="./Market/c-d-x-PDX_a_82obo-unsplash.png" srcset="./Market/c-d-x-PDX_a_82obo-unsplash.png 1x" />
			
		<img id="rachit-tank-2cFZ_FB08UM-unspla" src="./Market/rachit-tank-2cFZ_FB08UM-unspla.png" srcset="./Market/rachit-tank-2cFZ_FB08UM-unspla.png 1x" />
			
		<div id="Headphones_100_off">
			<span>Headphones 100% off</span>
		</div>
		<div id="Apple_Watch_90_off">
			<span>Apple Watch 90% off</span>
		</div>
		<div id="Group_19">
			<img id="previous_1" src="./Market/previous_1.png" srcset="./Market/previous_1.png 1x" />
				
		</div>
		<div id="Group_20">
			<img id="previous_1_by" src="./Market/previous_1_by.png" srcset="./Market/previous_1_by.png 1x" />
				
		</div>
	</div>
	<div id="Group_121">
		<img id="n_2188678_4907157_b" src="./Market/n_2188678_4907157_b.png" srcset="./Market/n_2188678_4907157_b.png 1x" />
			
		<div id="Top_Products">
			<span>Top Products</span>
		</div>
		<img id="eniko-kis-KsLPTsYaqIQ-unsplash" src="./Market/eniko-kis-KsLPTsYaqIQ-unsplash.png" srcset="./Market/eniko-kis-KsLPTsYaqIQ-unsplash.png 1x" />
			
		<img id="martin-katler-7wCxlBfGMdk-unsp" src="./Market/martin-katler-7wCxlBfGMdk-unsp.png" srcset="./Market/martin-katler-7wCxlBfGMdk-unsp.png 1x" />
			
		<div id="Camera">
			<span>Camera</span>
		</div>
		<div id="RTX_4090">
			<span>RTX 4090</span>
		</div>
		<div id="Group_21">
			<img id="previous_1_b" src="./Market/previous_1_b.png" srcset="./Market/previous_1_b.png 1x" />
				
		</div>
		<div id="Group_22">
			<img id="previous_1_ca" src="./Market/previous_1_ca.png" srcset="./Market/previous_1_ca.png 1x" />
				
		</div>
	</div>
	<div id="Group_123">
		<img id="n_2188678_4907157_cb" src="./Market/n_2188678_4907157_cb.png" srcset="./Market/n_2188678_4907157_cb.png 1x" />
			
		<div id="New_Launch">
			<span>New Launch</span>
		</div>
		<img id="tamara-bitter-JIrjoWIgFAs-unsp" src="./Market/tamara-bitter-JIrjoWIgFAs-unsp.png" srcset="./Market/tamara-bitter-JIrjoWIgFAs-unsp.png 1x" />
			
		<img id="ales-nesetril-Im7lZjxeLhg-unsp" src="./Market/ales-nesetril-Im7lZjxeLhg-unsp.png" srcset="./Market/ales-nesetril-Im7lZjxeLhg-unsp.png 1x" />
			
		<div id="PS_5_Delux_Edition">
			<span>PS 5 Delux Edition</span>
		</div>
		<div id="Apple_MacBook">
			<span>Apple MacBook</span>
		</div>
		<div id="Group_27">
			<img id="previous_1_ci" src="./Market/previous_1_ci.png" srcset="./Market/previous_1_ci.png 1x" />
				
		</div>
		<div id="Group_28">
			<img id="previous_1_ck" src="./Market/previous_1_ck.png" srcset="./Market/previous_1_ck.png 1x" />
				
		</div>
	</div>
	<div id="Group_120">
		<img id="n_2188678_4907157_cm" src="./Market/n_2188678_4907157_cm.png" srcset="./Market/n_2188678_4907157_cm.png 1x" />
			
		<img id="domino-164_6wVEHfI-unsplash" src="./Market/domino-164_6wVEHfI-unsplash.png" srcset="./Market/domino-164_6wVEHfI-unsplash.png 1x" />
			
		<img id="martin-katler-7wCxlBfGMdk-unsp_co" src="./Market/martin-katler-7wCxlBfGMdk-unsp_co.png" srcset="./Market/martin-katler-7wCxlBfGMdk-unsp_co.png 1x"/>
			
		<img id="paul-gaudriault-a-QH9MAAVNI-un" src="./Market/paul-gaudriault-a-QH9MAAVNI-un.png" srcset="./Market/paul-gaudriault-a-QH9MAAVNI-un.png 1x" />
			
		<img id="My_project" src="./Market/My_project.png" srcset="./Market/My_project.png 1x" />
			
		<div id="Recent_Visits">
			<span>Recent Visits</span>
		</div>
		<div id="RTX_4090_cs">
			<span>RTX 4090</span>
		</div>
		<div id="Canvas">
			<span>Canvas</span>
		</div>
		<div id="Construction">
			<span>Construction</span>
		</div>
		<div id="Sport_Shoe">
			<span>Sport Shoe</span>
		</div>
		<img id="previous_1_cw" src="./Market/previous_1_cw.png" srcset="./Market/previous_1_cw.png 1x" />
			
		<img id="previous_1_cx" src="./Market/previous_1_cx.png" srcset="./Market/previous_1_cx.png 1x" />
			
		<img id="previous_1_cy" src="./Market/previous_1_cy.png" srcset="./Market/previous_1_cy.png 1x" />
			
		<img id="previous_1_cz" src="./Market/previous_1_cz.png" srcset="./Market/previous_1_cz.png 1x" />
			
	</div>
	<div id="AD_AREA">
		<span>AD AREA</span>
	</div>
	<img id="My_project_3" src="./Market/My_project_3.png" srcset="./Market/My_project_3.png 1x" />
		
	<svg class="Rectangle_7">
		<rect id="Rectangle_7" rx="3" ry="3" x="0" y="0" width="28" height="35">
		</rect>
	</svg>
	<svg class="Rectangle_8">
		<rect id="Rectangle_8" rx="3" ry="3" x="0" y="0" width="28" height="35">
		</rect>
	</svg>
	<div id="Group_29">
		<img id="nike" src="./Market/nike.png" srcset="./Market/nike.png 1x" />
			
		<div id="SUP">
			<span>SUP</span>
		</div>
	</div>
	<svg class="Line_1" viewBox="0 0 3 36">
		<path id="Line_1" d="M 0 0 L 0 36">
		</path>
	</svg>
	<div id="Superro_Air">
		<span>Superro Air</span>
	</div>
	<img id="shoe" src="./Market/shoe.png" srcset="./Market/shoe.png 1x" />
		
	<img id="shoe_1" src="./Market/shoe_1.png" srcset="./Market/shoe_1.png 1x" />
		
	<img id="shoe_2" src="./Market/shoe_2.png" srcset="./Market/shoe_2.png 1x" />
		
	<div id="Group_30">
		<svg class="Rectangle_9">
			<rect id="Rectangle_9" rx="4" ry="4" x="0" y="0" width="85" height="33">
			</rect>
		</svg>
		<div id="Buy_Now">
			<span>Buy Now</span>
		</div>
	</div>
	<div id="Level_Up_Your_Style">
		<span>Level Up Your Style</span>
	</div>
	<img id="right-arrow_3" src="./Market/right-arrow_3.png" srcset="./Market/right-arrow_3.png 1x" />
		
	<img id="right-arrow_2" src="./Market/right-arrow_2.png" srcset="./Market/right-arrow_2.png 1x" />
		
	<div id="We_provide_best_customer_exper">
		<span>We provide best customer experience</span>
	</div>
	<svg class="Line_2" viewBox="0 0 1 78">
		<path id="Line_2" d="M 0 0 L 1 78">
		</path>
	</svg>
	<div id="We_ensure_our_customers_have_t">
		<span>We ensure our customers have the best shopping experience</span>
	</div>
	<div id="Card_03_market_pc">
		<div id="Moderate_children_at_of_outwei">
			<span>We offer fast and free shipping for our loyal customers.</span>
		</div>
		<div id="Track_Property">
			<span>Fast Shipping</span>
		</div>
		<div id="Icon">
			<div id="Fill">
				<svg class="Fill_du">
					<rect id="Fill_du" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Fill_du">
					<rect id="Fill_du" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Fill_du">
					<rect id="Fill_du" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Fill_du">
					<rect id="Fill_du" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Fill_du">
					<rect id="Fill_du" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Fill_dv">
					<rect id="Fill_dv" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
			</div>
			<svg class="Icon_dw" viewBox="0 0 21 25">
				<path id="Icon_dw" d="M 12.64968109130859 25 L 12.64968109130859 23.81291007995605 C 12.64968109130859 22.32072257995605 11.47156429290771 21.10393333435059 10.05224418640137 21.10393333435059 L 6.426092147827148 21.10393333435059 C 5.008571624755859 21.10393333435059 3.838554859161377 22.32072257995605 3.838554859161377 23.81291007995605 L 3.838554859161377 25 L 0 25 L 0 4.994060039520264 L 16.4792366027832 4.994060039520264 L 16.4792366027832 25 L 12.64968109130859 25 Z M 5.374876976013184 24.99730110168457 L 5.374876976013184 23.81471061706543 C 5.374876976013184 23.21621513366699 5.841083526611328 22.72391891479492 6.424292087554932 22.72391891479492 L 10.05404472351074 22.72391891479492 C 10.64175319671631 22.72391891479492 11.10615921020508 23.21621513366699 11.10615921020508 23.81471061706543 L 11.10615921020508 24.99730110168457 L 5.374876976013184 24.99730110168457 Z M 18.01735877990723 4.475664138793945 L 21 1.193390488624573 L 21 20.49013710021973 L 18.01735877990723 23.78410911560059 L 18.01735877990723 4.475664138793945 Z M 1.029614806175232 3.36957311630249 L 4.081558227539062 0 L 19.95328712463379 0 L 16.89054298400879 3.36957311630249 L 1.029614806175232 3.36957311630249 Z">
				</path>
			</svg>
		</div>
	</div>
	<div id="Card_02_market_pc">
		<div id="Conveying_or_northward_offendi">
			<span>We updates our collections almost everyday.</span>
		</div>
		<div id="Instant_Valuation">
			<span>New Arrival Everyday</span>
		</div>
		<svg class="Fill_d">
			<rect id="Fill_d" rx="20" ry="20" x="0" y="0" width="90" height="90">
			</rect>
		</svg>
		<svg class="Icon_d" viewBox="0 12.676 25 12.324">
			<path id="Icon_d" d="M 5.418792247772217 24.99990081787109 L 0 19.75759506225586 L 3.882311344146729 15.93109703063965 C 4.668544292449951 15.15043449401855 5.660660266876221 14.60584735870361 6.744654655456543 14.35991191864014 C 7.828649044036865 14.11397743225098 8.960536956787109 14.17667579650879 10.01025009155273 14.54080104827881 L 10.86327934265137 14.83671760559082 L 16.09707832336426 14.83671760559082 C 16.31842803955078 14.83661079406738 16.53754234313965 14.8806676864624 16.74140739440918 14.96627330780029 C 16.94527435302734 15.05187702178955 17.12973594665527 15.17728424072266 17.28384017944336 15.33504486083984 C 17.43794250488281 15.49280452728271 17.55854415893555 15.67970275878906 17.63848304748535 15.88463878631592 C 17.71842002868652 16.08957481384277 17.75606536865234 16.30837059020996 17.74917984008789 16.52803039550781 C 17.72404861450195 16.96222686767578 17.53091621398926 17.3699893951416 17.21012496948242 17.66614532470703 C 16.88933372497559 17.96230125427246 16.46569633483887 18.12393951416016 16.0277042388916 18.11730194091797 L 12.88793849945068 18.11730194091797 C 12.71757888793945 18.11730194091797 12.55419731140137 18.18449592590332 12.43373489379883 18.30409622192383 C 12.31327247619629 18.42369842529297 12.24559688568115 18.58591079711914 12.24559688568115 18.75505065917969 C 12.24559688568115 18.9241943359375 12.31327247619629 19.0864086151123 12.43373489379883 19.20601081848145 C 12.55419731140137 19.32561111450195 12.71757888793945 19.39280319213867 12.88793849945068 19.39280319213867 L 16.0379810333252 19.39280319213867 C 16.80636596679688 19.39653778076172 17.54676818847656 19.10675239562988 18.10588836669922 18.58344268798828 C 18.66501235961914 18.06013298034668 19.00002479553223 17.3433837890625 19.04156875610352 16.58160209655762 C 19.04156875610352 16.56884765625 19.04156875610352 16.55609130859375 19.04156875610352 16.54078483581543 L 21.95523071289062 13.28315830230713 C 22.25118446350098 12.94216537475586 22.66809463500977 12.72750854492188 23.11932182312012 12.68380165100098 C 23.57054901123047 12.64009380340576 24.02138900756836 12.77069664001465 24.37814331054688 13.04846668243408 C 24.55468368530273 13.19361305236816 24.70015335083008 13.37239742279053 24.80596733093262 13.57426929473877 C 24.91178131103516 13.77614307403564 24.97579574584961 13.99701309204102 24.99423599243164 14.22384929656982 C 25.01267623901367 14.45068550109863 24.98516654968262 14.67889022827148 24.91333389282227 14.89499855041504 C 24.84149742126465 15.11110687255859 24.72679138183594 15.31074142456055 24.57598304748535 15.4821195602417 L 18.75893974304199 22.11471939086914 C 18.3749885559082 22.55164527893066 17.90103530883789 22.90164184570312 17.36911964416504 23.14105224609375 C 16.83720397949219 23.38046455383301 16.25972175598145 23.50371170043945 15.67570114135742 23.50246429443359 L 6.9372878074646 23.49225997924805 L 5.418792247772217 24.99990081787109 Z">
			</path>
		</svg>
		<svg class="Icon_ea" viewBox="10.417 4.918 8.532 8.305">
			<path id="Icon_ea" d="M 18.59169578552246 8.214576721191406 C 18.36281585693359 7.987334728240967 18.05238914489746 7.859670162200928 17.72870826721191 7.859670162200928 L 15.93015193939209 7.859670162200928 L 15.93015193939209 6.073970317840576 C 15.91574859619141 5.762551784515381 15.78101062774658 5.468626022338867 15.55395030975342 5.253303527832031 C 15.32688999176025 5.037980556488037 15.02497863769531 4.917829036712646 14.71098804473877 4.917829036712646 C 14.39699649810791 4.917829036712646 14.09508609771729 5.037980556488037 13.86802577972412 5.253303527832031 C 13.64096546173096 5.468626022338867 13.50622749328613 5.762551784515381 13.49182415008545 6.073970317840576 L 13.49182415008545 7.859670162200928 L 11.69326782226562 7.859670162200928 C 11.52845573425293 7.852156162261963 11.36382102966309 7.877898216247559 11.20931243896484 7.935339450836182 C 11.0548038482666 7.992781162261963 10.91363048553467 8.080728530883789 10.7943229675293 8.193868637084961 C 10.67501449584961 8.307009696960449 10.58005046844482 8.4429931640625 10.51516914367676 8.593600273132324 C 10.45028686523438 8.744208335876465 10.41683578491211 8.906313896179199 10.41683578491211 9.070119857788086 C 10.41683578491211 9.233925819396973 10.45028686523438 9.396030426025391 10.51516914367676 9.546638488769531 C 10.58005046844482 9.697246551513672 10.67501449584961 9.833230018615723 10.7943229675293 9.946370124816895 C 10.91363048553467 10.05951118469238 11.0548038482666 10.14745903015137 11.20931243896484 10.20490074157715 C 11.36382102966309 10.26234149932861 11.52845573425293 10.28808307647705 11.69326782226562 10.28056907653809 L 13.49182415008545 10.28056907653809 L 13.49182415008545 12.06626892089844 C 13.50622749328613 12.37768745422363 13.64096546173096 12.6716136932373 13.86802577972412 12.88693618774414 C 14.09508609771729 13.10225868225098 14.39699649810791 13.22241020202637 14.71098804473877 13.22241020202637 C 15.02497863769531 13.22241020202637 15.32688999176025 13.10225868225098 15.55395030975342 12.88693618774414 C 15.78101062774658 12.6716136932373 15.91574859619141 12.37768745422363 15.93015193939209 12.06626892089844 L 15.93015193939209 10.28056907653809 L 17.72870826721191 10.28056907653809 C 18.05194473266602 10.2805700302124 18.36198234558105 10.15325736999512 18.59078788757324 9.926566123962402 C 18.8195915222168 9.699874877929688 18.94847679138184 9.392322540283203 18.94915771484375 9.071395874023438 L 18.94915771484375 9.071395874023438 C 18.94915771484375 8.750026702880859 18.8205738067627 8.441819190979004 18.59169578552246 8.214576721191406 Z">
			</path>
		</svg>
		<svg class="Icon_eb" viewBox="5.026 1.464 6.241 6.204">
			<path id="Icon_eb" d="M 7.248220920562744 3.673451662063599 L 5.924997329711914 3.673451662063599 C 5.68649435043335 3.673451662063599 5.457758903503418 3.767519950866699 5.289111614227295 3.934961557388306 C 5.120464324951172 4.10240364074707 5.02571964263916 4.329503059387207 5.02571964263916 4.566302299499512 C 5.02571964263916 4.8031005859375 5.120464324951172 5.030200481414795 5.289111614227295 5.19764232635498 C 5.457758903503418 5.365084171295166 5.68649435043335 5.459152221679688 5.924997329711914 5.459152221679688 L 7.250790119171143 5.459152221679688 L 7.250790119171143 6.775467872619629 C 7.250790119171143 7.012266635894775 7.345535278320312 7.23936653137207 7.514182567596436 7.406808376312256 C 7.682829856872559 7.574250221252441 7.911564350128174 7.668318271636963 8.150068283081055 7.668318271636963 C 8.388571739196777 7.668318271636963 8.617306709289551 7.574250221252441 8.785953521728516 7.406808376312256 C 8.954601287841797 7.23936653137207 9.049345970153809 7.012266635894775 9.049345970153809 6.775467872619629 L 9.049345970153809 5.454050064086914 L 10.367431640625 5.454050064086914 C 10.60593509674072 5.454050064086914 10.83466911315918 5.359982013702393 11.00331687927246 5.192540168762207 C 11.17196369171143 5.025098323822021 11.26671028137207 4.797998428344727 11.26671028137207 4.561200141906738 C 11.26671028137207 4.324401378631592 11.17196369171143 4.097301483154297 11.00331687927246 3.929859399795532 C 10.83466911315918 3.762417793273926 10.60593509674072 3.668349742889404 10.367431640625 3.668349742889404 L 9.041638374328613 3.668349742889404 L 9.041638374328613 2.357135534286499 C 9.041638374328613 2.120337009429932 8.946893692016602 1.893237233161926 8.77824592590332 1.725795388221741 C 8.609599113464355 1.558353543281555 8.380864143371582 1.464285612106323 8.142360687255859 1.464285612106323 C 7.903857231140137 1.464285612106323 7.675121784210205 1.558353543281555 7.506474494934082 1.725795388221741 C 7.337827205657959 1.893237233161926 7.243082523345947 2.120337009429932 7.243082523345947 2.357135534286499 L 7.248220920562744 2.357135534286499 L 7.248220920562744 3.673451662063599 Z">
			</path>
		</svg>
		<svg class="Icon_ec" viewBox="15.91 0 5.365 5.326">
			<path id="Icon_ec" d="M 18.04701232910156 0.2241511791944504 C 17.90245819091797 0.3676727414131165 17.82124900817871 0.5623298287391663 17.82124900817871 0.7652999758720398 L 17.82124900817871 1.89794397354126 L 16.68045043945312 1.89794397354126 C 16.47601890563965 1.89794397354126 16.27996253967285 1.978573560714722 16.13540649414062 2.122095346450806 C 15.99085140228271 2.265616893768311 15.90964126586914 2.460273742675781 15.90964126586914 2.663244009017944 C 15.90964126586914 2.866214036941528 15.99085140228271 3.060871124267578 16.13540649414062 3.204392910003662 C 16.27996253967285 3.347914457321167 16.47601890563965 3.42854380607605 16.68045043945312 3.42854380607605 L 17.82124900817871 3.42854380607605 L 17.82124900817871 4.561188220977783 C 17.82124900817871 4.764157772064209 17.90245819091797 4.958815097808838 18.04701232910156 5.102336883544922 C 18.19156837463379 5.245858192443848 18.38762664794922 5.326488018035889 18.5920581817627 5.326488018035889 C 18.79648971557617 5.326488018035889 18.9925479888916 5.245858192443848 19.13710403442383 5.102336883544922 C 19.28165817260742 4.958815097808838 19.36286926269531 4.764157772064209 19.36286926269531 4.561188220977783 L 19.36286926269531 3.42854380607605 L 20.5036678314209 3.42854380607605 C 20.60489273071289 3.42854380607605 20.70512390136719 3.408748865127563 20.79864311218262 3.370289087295532 C 20.89216232299805 3.331829071044922 20.97713661193848 3.275457382202148 21.04871368408203 3.204392910003662 C 21.12029075622559 3.133328199386597 21.17706489562988 3.048962116241455 21.21580123901367 2.956111669540405 C 21.25453948974609 2.863260984420776 21.27447700500488 2.763744354248047 21.27447700500488 2.663244009017944 C 21.27447700500488 2.562743186950684 21.25453948974609 2.463226556777954 21.21580123901367 2.370376348495483 C 21.17706489562988 2.277525901794434 21.12029075622559 2.193160057067871 21.04871368408203 2.122095346450806 C 20.97713661193848 2.051030397415161 20.89216232299805 1.994658946990967 20.79864311218262 1.956199049949646 C 20.70512390136719 1.917739272117615 20.60489273071289 1.89794397354126 20.5036678314209 1.89794397354126 L 19.36286926269531 1.89794397354126 L 19.36286926269531 0.7652999758720398 C 19.36286926269531 0.5623298287391663 19.28165817260742 0.3676727414131165 19.13710403442383 0.2241511791944504 C 18.9925479888916 0.08062958717346191 18.79648971557617 1.132871626843552e-16 18.5920581817627 0 L 18.5920581817627 0 C 18.38762664794922 1.699307307916431e-16 18.19156837463379 0.08062958717346191 18.04701232910156 0.2241511791944504 Z">
			</path>
		</svg>
	</div>
	<div id="Card_01_market_pc">
		<div id="Wonder_twenty_hunted_and_put_i">
			<span>We provide guarantee original product.</span>
		</div>
		<div id="Research_Suburbs_market_pc">
			<span>Original Product</span>
		</div>
		<svg class="Fill_bdr_market_pc">
			<rect id="Fill_bdr_market_pc" rx="20" ry="20" x="0" y="0" width="90" height="90">
			</rect>
		</svg>
		<svg class="Icon__2_market_pc" viewBox="17.672 17.672 7.328 7.328">
			<path id="Icon__2_market_pc" d="M 24.99994087219238 24.99994087219238 L 17.67241287231445 17.67241287231445">
			</path>
		</svg>
		<svg class="Icon_1_market_pc" viewBox="0 0 20.689 20.689">
			<path id="Icon_1_market_pc" d="M 20.68948936462402 10.34474468231201 C 20.68948936462402 4.631499767303467 16.0579891204834 0 10.34474468231201 0 C 4.631499767303467 0 0 4.631499767303467 0 10.34474468231201 C 0 16.0579891204834 4.631499767303467 20.68948936462402 10.34474468231201 20.68948936462402 C 16.0579891204834 20.68948936462402 20.68948936462402 16.0579891204834 20.68948936462402 10.34474468231201 Z">
			</path>
		</svg>
	</div>
	<div id="line_design_1_grp">
		<svg class="line_centre_2_market_pc" viewBox="0 0 191.5 3">
			<path id="line_centre_2_market_pc" d="M 0 0 L 191.5 0">
			</path>
		</svg>
		<svg class="line_bal2_market_pc">
			<ellipse id="line_bal2_market_pc" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
			</ellipse>
		</svg>
		<svg class="line_bal1_market_pc">
			<ellipse id="line_bal1_market_pc" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
			</ellipse>
		</svg>
	</div>
	<div id="line_design_2_grp">
		<svg class="centre_line_2_market_pc" viewBox="0 0 191.5 3">
			<path id="centre_line_2_market_pc" d="M 0 0 L 191.5 0">
			</path>
		</svg>
		<svg class="circle_1_market_pc">
			<ellipse id="circle_1_market_pc" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
			</ellipse>
		</svg>
		<svg class="circle_2_market_pc">
			<ellipse id="circle_2_market_pc" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
			</ellipse>
		</svg>
	</div>

	<div id="View_All_Products_market_pc">
		<span>View All Products</span>
	</div>
	<div id="Colonel_gravity_get_thought_fa">
		<span>Get the best deal here !!</span>
	</div>
	<div id="Best_Deals_market_pc">
		<span>Best Deals</span>
	</div>
	<div id="phone_grp_market_pc">
		<img id="anh-nhat-uCqMa_s-JDg-unsplash" src="./Market/anh-nhat-uCqMa_s-JDg-unsplash.png" srcset="./Market/anh-nhat-uCqMa_s-JDg-unsplash.png 1x" />
			
		<svg class="shade_white_market_pc">
			<rect id="shade_white_market_pc" rx="4" ry="4" x="0" y="0" width="89" height="42">
			</rect>
		</svg>
		<svg class="bdr_best_seller_market_pc">
			<rect id="bdr_best_seller_market_pc" rx="4" ry="4" x="0" y="0" width="85" height="33">
			</rect>
		</svg>
		<div id="Best_Seller_market_pc">
			<span>Best Seller</span>
		</div>
	</div>
	<div id="clothes_grp_market_pc">
		<img id="mediamodifier-kJXGTOY1wLQ-unsp" src="./Market/mediamodifier-kJXGTOY1wLQ-unsp.png" srcset="./Market/mediamodifier-kJXGTOY1wLQ-unsp.png 1x" />
			
		<svg class="shade_clothes_market_pc">
			<rect id="shade_clothes_market_pc" rx="4" ry="4" x="0" y="0" width="89" height="42">
			</rect>
		</svg>
		<svg class="clothes_bdr_top_market_pc">
			<rect id="clothes_bdr_top_market_pc" rx="4" ry="4" x="0" y="0" width="85" height="33">
			</rect>
		</svg>
		<div id="Top_Brands_shirt_market_pc">
			<span>Top Brands</span>
		</div>
	</div>
	<div id="shoes_grp_market_pc">
		<img id="shoes_img_market_pc" src="./Market/shoes_img_market_pc.png" srcset="./Market/shoes_img_market_pc.png 1x" />
			
		<svg class="shade_shoes_market_pc">
			<rect id="shade_shoes_market_pc" rx="4" ry="4" x="0" y="0" width="89" height="42">
			</rect>
		</svg>
		<svg class="top_brand_bdr_market_pc">
			<rect id="top_brand_bdr_market_pc" rx="4" ry="4" x="0" y="0" width="85" height="33">
			</rect>
		</svg>
		<div id="Top_Brands_lbl_market_pc">
			<span>Top Brands</span>
		</div>
	</div>
	<div id="pips_grp_market_pc">
		<img id="img_pipe_market_pc" src="./Market/img_pipe_market_pc.png" srcset="./Market/img_pipe_market_pc.png 1x" />
			
		<svg class="shade_blue_market_pc">
			<rect id="shade_blue_market_pc" rx="4" ry="4" x="0" y="0" width="89" height="42">
			</rect>
		</svg>
		<svg class="bdr_best_quality_market_pc">
			<rect id="bdr_best_quality_market_pc" rx="4" ry="4" x="0" y="0" width="85" height="33">
			</rect>
		</svg>
		<div id="Best_Quality_lbl_market_pc">
			<span>Best Quality</span>
		</div>
	</div>
	<div id="best_deals_category_market_pc">
		<img id="Image_01_market_pc" src="./Market/Image_01_market_pc.png" srcset="./Market/Image_01_market_pc.png 1x" />
			
		<svg class="bdr_add_cart_market_pc">
			<rect id="bdr_add_cart_market_pc" rx="4" ry="4" x="0" y="0" width="35" height="35">
			</rect>
		</svg>
		<img id="add-to-cart_1_market_pc" src="./Market/add-to-cart_1_market_pc.png" srcset="./Market/add-to-cart_1_market_pc.png 1x" />
			
		<div id="air_shoes_market_pc">
			<span>Air Shoes</span>
		</div>
		<div id="n_00_market_pc">
			<span>$500</span>
		</div>
		<img id="Image_02_market_pc" src="./Market/Image_02_market_pc.png" srcset="./Market/Image_02_market_pc.png 1x" />
			
		<svg class="bdr_cart_market_pc">
			<rect id="bdr_cart_market_pc" rx="4" ry="4" x="0" y="0" width="35" height="35">
			</rect>
		</svg>
		<img id="add-to-cart_img_market_pc" src="./Market/add-to-cart_img_market_pc.png" srcset="./Market/add-to-cart_img_market_pc.png 1x" />
			
		<div id="Featured_name_market_pc">
			<span>Cotton Clothes</span>
		</div>
		<div id="Featured_1_market_pc">
			<span>$500</span>
		</div>
		<img id="Image_03_add-to-cart_1_market_" src="./Market/Image_03_add-to-cart_1_market_.png" srcset="./Market/Image_03_add-to-cart_1_market_.png 1x" />
			
		<svg class="add-to-cart_1_bdr__market_pc">
			<rect id="add-to-cart_1_bdr__market_pc" rx="4" ry="4" x="0" y="0" width="35" height="35">
			</rect>
		</svg>
		<img id="add-to-cart_1_market_pc_fk" src="./Market/add-to-cart_1_market_pc_fk.png" srcset="./Market/add-to-cart_1_market_pc_fk.png 1x" />
			
		<div id="Featured_456_market_pc">
			<span>Jeans</span>
		</div>
		<div id="Featured_123_market_pc">
			<span>$500</span>
		</div>
	</div>
	<button class="button_market">
		View All Events
		</button>
</div>
  )
}

export default MarketPCUI
